import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import FlowIcon from '@/comp/common/icons/FlowIcon';
import { MetricType } from '@/constants/metric-type.enum';
import UnitsEnum from '@/constants/unitsEnum';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { FlowSensorNodeModel } from './FlowSensorNodeModel';
import SensorNodeWidget from '../../components/SensorNodeWidget/SensorNodeWidget';

export class FlowSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.FlowSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new FlowSensorNodeModel();
  }

  nodeUI(event) {
    return (
      <SensorNodeWidget
        engine={this.engine}
        node={event.model}
        width={50}
        height={44}
        data={[
          {
            metric: MetricType.FlowM3Min,
            unit: UnitsEnum.m3Min,
            Icon: <FlowIcon />,
          },
        ]}
      />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
